import { render } from "./SortingIcons.vue?vue&type=template&id=32d3e944"
import script from "./SortingIcons.vue?vue&type=script&lang=js"
export * from "./SortingIcons.vue?vue&type=script&lang=js"

import "./SortingIcons.vue?vue&type=style&index=0&id=32d3e944&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__